import Vue from 'vue'
import App from './App.vue'
import VueClipboard from 'vue-clipboard2'
import Buefy from 'buefy'
import 'buefy/dist/buefy.css'
import router from './router'
import store from './store'

Vue.config.productionTip = false
Vue.use(Buefy)
Vue.use(VueClipboard)
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
